import { Bound } from "lib/@components/binding/Bound"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { InlineCompareButtons } from "routes/schedule/compare/inline-approval-buttons/inline-compare-buttons"
import { AuthoringReviewAmendsBlock } from "./authoring-review-amends-block"
import { AuthoringReviewPriorRejection } from "./authoring-review-prior-rejection"
import { AuthoringReviewIntroValue } from "./authoring-review-intro-value"
import { normalizeAuthoringComparisonText } from "./lib/authoring-comparison-normalization"
import { AuthoringSideBySideRow } from "./authoring-side-by-side-row"
import { Box } from "@mui/material"

export function AuthoringReviewSideBySideIntroRow({ field, label, idFromGroup, amendsKey, subtitle, dataCy }) {
    const { target, comparisonTarget } = useBoundContext()
    const hasDifference = !valuesMatch(
        getIntroFieldValue(target?.intro, field),
        getIntroFieldValue(comparisonTarget?.intro, field)
    )

    return (
        <Bound acceptId={idFromGroup} showEditor={true} hideUpBar={true} hideToolbar={true}>
            <AuthoringSideBySideRow
                left={
                    <AuthoringReviewIntroValue
                        label={label}
                        value={getIntroFieldValue(target?.intro, field)}
                        comparisonValue={getIntroFieldValue(comparisonTarget?.intro, field)}
                        dataCy={dataCy}
                    />
                }
                right={
                    <AuthoringReviewIntroValue
                        label={label}
                        value={getIntroFieldValue(comparisonTarget?.intro, field)}
                        comparisonValue={getIntroFieldValue(target?.intro, field)}
                        showRemoved
                        dataCy={`${dataCy}-comparison`}
                    />
                }
                after={
                    hasDifference ? (
                        <Box className="after" ml={4} mb={1}>
                            <InlineCompareButtons idFromGroup={idFromGroup} to={target} from={comparisonTarget} />
                        </Box>
                    ) : null
                }
                below={
                    <>
                        <AuthoringReviewPriorRejection amendsKey={amendsKey} />
                        <If truthy={hasDifference}>
                            <AuthoringReviewAmendsBlock
                                amendsKey={amendsKey}
                                subtitle={subtitle}
                                cyPrefix="side-by-side-amends"
                            />
                        </If>
                    </>
                }
            />
        </Bound>
    )
}

function getIntroFieldValue(intro, field) {
    if (field === "note") return intro?.note ?? intro?.notes ?? ""
    return intro?.[field] ?? ""
}

function valuesMatch(left, right) {
    return normalizeAuthoringComparisonText(left) === normalizeAuthoringComparisonText(right)
}
